import { render, staticRenderFns } from "./widget-message.vue?vue&type=template&id=2c285d2f&"
import script from "./widget-message.vue?vue&type=script&lang=js&"
export * from "./widget-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports